import React from 'react'
import { Box, Typography, Paper, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { ExpandMore, ChevronRight } from '@mui/icons-material';

const jsondata = require('../assets/windows_client.json')

const PageSize = 25

const renderDownloadLink = (params) => {
    // console.log(params)
    if (params.value) {
        return <a href={"files/windows-client/" + params.value} download>{params.value}</a>
    }
    return ""
}

const renderNotes = (params) => {
    // console.log(params)
    if (params.value) {
        const text = params.value
        return (
            <Box sx={{ width: '100%', borderRadius: 1, border: '1px solid grey', p: 2 }}>
                <Typography variant="body1" gutterBottom>
                    {text}
                </Typography>
            </Box>
        );
    }
    return ""
}

const columns = [
    { field: 'name', headerName: 'Name', minWidth: 280, renderCell: renderDownloadLink, sortable: false },
    { field: 'version', headerName: 'Version', minWidth: 180, sortable: false },
    { field: 'size', headerName: 'Size', minWidth: 50, sortable: false },
    { field: 'created', headerName: 'Created', minWidth: 220, sortable: false },
    { field: 'sha256', headerName: 'SHA256', minWidth: 550, sortable: false },
];

const sortModel = [
    {
        field: 'created', // the name of the field to sort by
        sort: 'desc', // 'desc' or 'asc'
    },
];

const IsLatest = (ver, latestVer) => {
    if (ver === latestVer) {
        return "Yes"
    }
    return ""
}

const ClientApp = () => {

    const imageArray = jsondata.images

    imageArray.forEach((item) => {
        if (IsLatest(item.version, jsondata.latest)) {
            item.latest = 'Yes'
        }
    });

    const [, setPage] = React.useState(1);
    
    // Sort the data by created date in descending order
    const sortedRows = [...jsondata.images].sort((a, b) => new Date(b.created) - new Date(a.created));
    const [rows] = React.useState(sortedRows);
    const [showAllRows, setShowAllRows] = React.useState(false);

    const latestVersion = rows.find(row => row.version === jsondata.latest);
    const otherVersions = rows.filter(row => row.version !== jsondata.latest);

    return (
        <Box sx={{ m: 10 }}>
            <Typography variant='h3'>Windows Client</Typography>
            {latestVersion && (
                <DataGrid
                    autoHeight
                    rows={[latestVersion]}
                    columns={columns}
                    getRowHeight={() => 'auto'}
                    getRowId={(row) => row.name}
                    pagination={false}
                    hideFooter
                    disableColumnMenu={true}
                    disableColumnSelector={true}
                    disableColumnSorting={true}
                />
            )}
            {otherVersions.length > 0 && (
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Button 
                        variant="text" 
                        onClick={() => setShowAllRows(!showAllRows)}
                        sx={{ textTransform: 'none', color: 'text.secondary' }}
                        startIcon={showAllRows ? <ExpandMore /> : <ChevronRight />}
                    >
                        {showAllRows ? 'Hide older versions' : `Show all versions (${rows.length} total)`}
                    </Button>
                </Box>
            )}
            {showAllRows && otherVersions.length > 0 && (
                <DataGrid
                    autoHeight
                    rows={otherVersions}
                    columns={columns}
                    getRowHeight={() => 'auto'}
                    getRowId={(row) => row.name}
                    pagination
                    pageSize={PageSize}
                    rowsPerPageOptions={[PageSize]}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }}
                    disableColumnMenu={true}
                    disableColumnSelector={true}
                    disableColumnSorting={true}
                />
            )}
        </Box>
    )
}

export default ClientApp